const withParticipant = participantId => prevParticipantIds => [
    ...prevParticipantIds,
    participantId,
];

export default withParticipant;
